// extracted by mini-css-extract-plugin
export var phone = "_34-0";